export const GET_PROVISION_STATUS_DEF= "GET_PROVISION_STATUS_DEF"
export const GET_PROVISION_STATUS_DEF_SUCCESS = "GET_PROVISION_STATUS_DEF_SUCCESS"
export const GET_PROVISION_STATUS_DEF_FAIL = "GET_PROVISION_STATUS_DEF_FAIL"

export const PROVISION_STATUS_DEF_API_ERROR = "API_ERROR"